import React from 'react';
import PropTypes from 'prop-types';

const Footer = props => {
	const { startYear, endYear, totalReviews } = props;

	const determineStartEndYear = (y1, y2) => {
		const currentYear = new Date().getFullYear();
		const start = String(y1 === 'current' ? currentYear : y1);
		const end = String(y2 === 'current' ? currentYear : y2);
		const separator = !start || !end ? '' : '–';
		return start === end ? start : `${start}${separator}${end}`;
	};

	return (
		<div className="kbb-footer mt-3">
			{totalReviews &&
				startYear &&
				endYear && (
					<span>
						<span className="kbb-footer-text text-muted">
							Based on {totalReviews} consumer ratings for{' '}
							{determineStartEndYear(startYear, endYear)} models.
						</span>
						<span
							className="text-muted separator "
							aria-hidden="true"
						>
							&nbsp;|&nbsp;
						</span>
					</span>
				)}

			<a
				className="kbb-privacy-link"
				target="_blank"
				rel="noopener noreferrer"
				href="https://www.kbb.com/company/privacy-policy/"
			>
				Privacy{' '}
			</a>
		</div>
	);
};

Footer.propTypes = {
	startYear: PropTypes.string.isRequired,
	endYear: PropTypes.string.isRequired,
	totalReviews: PropTypes.number.isRequired
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.jsx